import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { DesignWrapper } from '../../design/design.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class CobolWrapper extends DatabaseWrapper {
	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.cobol.ID;
		this.name = DatabaseEnum.cobol.NAME;
		this.code = DatabaseEnum.cobol.CODE;
		//data object tabs
		this.showDataObjectPropertiesTab = true;
		this.showViewDataTabOption = true;
		this.isShowObjProperties = true;
		this.isFileType = true;
		this.equivalentTag = 'cbid';
		this.showPromoteAttributes = true;
		this.showDemoteAttributes = true;
    this.showDataDescription = false;

	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {
		if (!repConnWrapper.repConn.conn.fileloc.length) {
			repConnWrapper.inValid_Cds.push('NO_FILELOC');
		}


		if (repConnWrapper.repConn.conn.ftpFlag == 'Y') {
			if (!repConnWrapper.repConn.conn.ftpHost.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_HOST');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_HOST');

			}
			if (!repConnWrapper.repConn.conn.ftpPort.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_PORT');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_PORT');

			}
			if (!repConnWrapper.repConn.conn.ftpUsr.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_CONN_USR');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_CONN_USR');

			}
			if (!repConnWrapper.repConn.conn.ftpPasswd.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_PASSWORD');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_PASSWORD');

			}
		}
		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getClevel(objectWrapper, true),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getFormat(objectWrapper),
			//this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getDist_FieldOffset(objectWrapper),
			this.attributeTabulator.getDist_FieldSize(objectWrapper),
			this.attributeTabulator.getFldFormatValue(objectWrapper),
			this.attributeTabulator.getOccurs(objectWrapper),
			this.attributeTabulator.getTranspose(objectWrapper),
			this.attributeTabulator.getRedefines(objectWrapper),
			this.attributeTabulator.getDependingOn(objectWrapper),
			this.attributeTabulator.getFldValue(objectWrapper),
			//this.attributeTabulator.getSigned(objectWrapper),
			//this.attributeTabulator.getTsigned(objectWrapper),
			//this.attributeTabulator.getIsigned(objectWrapper),
			//this.attributeTabulator.getRdeci(objectWrapper),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, isMax: boolean = false,component:any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}

	showAttributeTranspose(attribute: Attribute, objectWrapper: ObjectWrapper): boolean {
		if (attribute.occurs <= 1) return false;
		return true

	}

	readFileCutOffLength(type: string): number {
        return -1;
    }
}
